// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import StrikethroughOutlinedSvg from "@fishx/icons-svg/es/asn/StrikethroughOutlined";
import FishxIcon from '../components/FishxIcon';

var StrikethroughOutlined = function StrikethroughOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: StrikethroughOutlinedSvg
  }));
};

StrikethroughOutlined.displayName = 'StrikethroughOutlined';
export default React.forwardRef(StrikethroughOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/StrikethroughOutlined.js
// module id = 4208
// module chunks = 0